import { memo, useCallback } from "react";
import { Stack } from "@mui/material";
import { FieldFormCheckboxRow } from "../FieldFormCheckboxRow";
import { FieldTypeEditorProps } from "../types";

export const TaxIdFieldTypeSpecificProps = memo(
  ({ field, onChange }: FieldTypeEditorProps) => {
    const updateProp = useCallback(
      <K extends keyof typeof field>(key: K, value: typeof field[K]) => {
        onChange({ ...field, [key]: value });
      },
      [field, onChange],
    );

    return (
      <Stack spacing={1.5} sx={{ pt: 0.5 }}>
        <FieldFormCheckboxRow
          label='Allow multiple'
          checked={!!field.multiple}
          onChange={(checked) => updateProp("multiple", checked)}
        />
      </Stack>
    );
  },
);
